function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 2,
  fill: "#F3F3F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3077 4.18385C13.85 4.38462 13.3623 4.51769 12.8538 4.58231C13.3769 4.27 13.7762 3.77923 13.9638 3.18769C13.4762 3.47846 12.9377 3.68385 12.3638 3.79846C11.9008 3.30538 11.2408 3 10.5208 3C9.12385 3 7.99923 4.13385 7.99923 5.52385C7.99923 5.72385 8.01615 5.91615 8.05769 6.09923C5.96 5.99692 4.10385 4.99154 2.85692 3.46C2.63923 3.83769 2.51154 4.27 2.51154 4.73538C2.51154 5.60923 2.96154 6.38385 3.63231 6.83231C3.22692 6.82462 2.82923 6.70692 2.49231 6.52154C2.49231 6.52923 2.49231 6.53923 2.49231 6.54923C2.49231 7.77538 3.36692 8.79385 4.51385 9.02846C4.30846 9.08462 4.08462 9.11154 3.85231 9.11154C3.69077 9.11154 3.52769 9.10231 3.37462 9.06846C3.70154 10.0677 4.62923 10.8023 5.73231 10.8262C4.87385 11.4977 3.78385 11.9023 2.60385 11.9023C2.39692 11.9023 2.19846 11.8931 2 11.8677C3.11769 12.5885 4.44231 13 5.87077 13C10.5138 13 13.0523 9.15385 13.0523 5.82C13.0523 5.70846 13.0485 5.60077 13.0431 5.49385C13.5438 5.13846 13.9646 4.69462 14.3077 4.18385Z",
  fill: "#292929"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twitter.e98b565e.svg";
export { ForwardRef as ReactComponent };